import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingBackdrop = (props) => {
    const { loading } = props;

    return (
        <div>
            <Backdrop sx={{ color: '#fff', zIndex: 100 }} open={loading} >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default LoadingBackdrop;